import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type EventPersonMediaReactionStateFragment = { __typename?: 'EventPersonMediaReaction'; mediaId: string; types: Array<Types.MediaReactionType>; id: string };

export type EventPersonMediaReactionsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  mediaIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type EventPersonMediaReactionsQuery = {
  __typename?: 'Query';
  eventPersonMediaReactions: Array<{ __typename?: 'EventPersonMediaReaction'; mediaId: string; types: Array<Types.MediaReactionType>; id: string }>;
};

export type MediaReactorsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  mediaId: Types.Scalars['ID'];
  type?: Types.InputMaybe<Types.MediaReactionType>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  cursor?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type MediaReactorsQuery = {
  __typename?: 'Query';
  mediaReactors: {
    __typename?: 'MediaReactionListResult';
    nextCursor?: string | null;
    reactors: Array<{ __typename?: 'MediaReactor'; id: string; displayName: string; types: Array<Types.MediaReactionType> }>;
  };
};

export type MediaReactionTarget_MediaPhoto_Fragment = {
  __typename?: 'MediaPhoto';
  id: string;
  reactions: Array<{ __typename?: 'MediaReactionCount'; id: string; type: Types.MediaReactionType; count: number }>;
};

export type MediaReactionTarget_MediaVideo_Fragment = {
  __typename?: 'MediaVideo';
  id: string;
  reactions: Array<{ __typename?: 'MediaReactionCount'; id: string; type: Types.MediaReactionType; count: number }>;
};

export type MediaReactionTargetFragment = MediaReactionTarget_MediaPhoto_Fragment | MediaReactionTarget_MediaVideo_Fragment;

export type AddReactionToMediaMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  mediaCollectionId: Types.Scalars['ID'];
  mediaId: Types.Scalars['ID'];
  type: Types.MediaReactionType;
}>;

export type AddReactionToMediaMutation = {
  __typename?: 'Mutation';
  addReactionToMedia:
    | { __typename?: 'MediaPhoto'; id: string; reactions: Array<{ __typename?: 'MediaReactionCount'; id: string; type: Types.MediaReactionType; count: number }> }
    | { __typename?: 'MediaVideo'; id: string; reactions: Array<{ __typename?: 'MediaReactionCount'; id: string; type: Types.MediaReactionType; count: number }> };
};

export type RemoveReactionFromMediaMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  mediaId: Types.Scalars['ID'];
  type: Types.MediaReactionType;
}>;

export type RemoveReactionFromMediaMutation = {
  __typename?: 'Mutation';
  removeReactionFromMedia:
    | { __typename?: 'MediaPhoto'; id: string; reactions: Array<{ __typename?: 'MediaReactionCount'; id: string; type: Types.MediaReactionType; count: number }> }
    | { __typename?: 'MediaVideo'; id: string; reactions: Array<{ __typename?: 'MediaReactionCount'; id: string; type: Types.MediaReactionType; count: number }> };
};

export const EventPersonMediaReactionStateFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventPersonMediaReactionState' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPersonMediaReaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const MediaReactionTargetFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MediaReactionTarget' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaVideo' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const EventPersonMediaReactionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventPersonMediaReactions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaIds' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventPersonMediaReactions' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'mediaIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaIds' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventPersonMediaReactionState' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventPersonMediaReactionState' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPersonMediaReaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mediaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventPersonMediaReactionsQuery__
 *
 * To run a query within a React component, call `useEventPersonMediaReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPersonMediaReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPersonMediaReactionsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      mediaIds: // value for 'mediaIds'
 *   },
 * });
 */
export function useEventPersonMediaReactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventPersonMediaReactionsQuery, EventPersonMediaReactionsQueryVariables>) {
  return ApolloReactHooks.useQuery<EventPersonMediaReactionsQuery, EventPersonMediaReactionsQueryVariables>(EventPersonMediaReactionsDocument, baseOptions);
}
export function useEventPersonMediaReactionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventPersonMediaReactionsQuery, EventPersonMediaReactionsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<EventPersonMediaReactionsQuery, EventPersonMediaReactionsQueryVariables>(EventPersonMediaReactionsDocument, baseOptions);
}
export type EventPersonMediaReactionsQueryHookResult = ReturnType<typeof useEventPersonMediaReactionsQuery>;
export type EventPersonMediaReactionsLazyQueryHookResult = ReturnType<typeof useEventPersonMediaReactionsLazyQuery>;
export type EventPersonMediaReactionsQueryResult = Apollo.QueryResult<EventPersonMediaReactionsQuery, EventPersonMediaReactionsQueryVariables>;
export const MediaReactorsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MediaReactors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaReactionType' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mediaReactors' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'mediaId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'cursor' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'cursor' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nextCursor' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'types' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMediaReactorsQuery__
 *
 * To run a query within a React component, call `useMediaReactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaReactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaReactorsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      mediaId: // value for 'mediaId'
 *      type: // value for 'type'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useMediaReactorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaReactorsQuery, MediaReactorsQueryVariables>) {
  return ApolloReactHooks.useQuery<MediaReactorsQuery, MediaReactorsQueryVariables>(MediaReactorsDocument, baseOptions);
}
export function useMediaReactorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaReactorsQuery, MediaReactorsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MediaReactorsQuery, MediaReactorsQueryVariables>(MediaReactorsDocument, baseOptions);
}
export type MediaReactorsQueryHookResult = ReturnType<typeof useMediaReactorsQuery>;
export type MediaReactorsLazyQueryHookResult = ReturnType<typeof useMediaReactorsLazyQuery>;
export type MediaReactorsQueryResult = Apollo.QueryResult<MediaReactorsQuery, MediaReactorsQueryVariables>;
export const AddReactionToMediaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddReactionToMedia' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaCollectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaReactionType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addReactionToMedia' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'mediaCollectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaCollectionId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'mediaId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaReactionTarget' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MediaReactionTarget' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaVideo' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddReactionToMediaMutationFn = Apollo.MutationFunction<AddReactionToMediaMutation, AddReactionToMediaMutationVariables>;

/**
 * __useAddReactionToMediaMutation__
 *
 * To run a mutation, you first call `useAddReactionToMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionToMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionToMediaMutation, { data, loading, error }] = useAddReactionToMediaMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      mediaCollectionId: // value for 'mediaCollectionId'
 *      mediaId: // value for 'mediaId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddReactionToMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddReactionToMediaMutation, AddReactionToMediaMutationVariables>) {
  return ApolloReactHooks.useMutation<AddReactionToMediaMutation, AddReactionToMediaMutationVariables>(AddReactionToMediaDocument, baseOptions);
}
export type AddReactionToMediaMutationHookResult = ReturnType<typeof useAddReactionToMediaMutation>;
export type AddReactionToMediaMutationResult = Apollo.MutationResult<AddReactionToMediaMutation>;
export type AddReactionToMediaMutationOptions = Apollo.BaseMutationOptions<AddReactionToMediaMutation, AddReactionToMediaMutationVariables>;
export const RemoveReactionFromMediaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveReactionFromMedia' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaReactionType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeReactionFromMedia' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'mediaId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'mediaId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaReactionTarget' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MediaReactionTarget' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventMedia' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaPhoto' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaVideo' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RemoveReactionFromMediaMutationFn = Apollo.MutationFunction<RemoveReactionFromMediaMutation, RemoveReactionFromMediaMutationVariables>;

/**
 * __useRemoveReactionFromMediaMutation__
 *
 * To run a mutation, you first call `useRemoveReactionFromMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionFromMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionFromMediaMutation, { data, loading, error }] = useRemoveReactionFromMediaMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      mediaId: // value for 'mediaId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRemoveReactionFromMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveReactionFromMediaMutation, RemoveReactionFromMediaMutationVariables>) {
  return ApolloReactHooks.useMutation<RemoveReactionFromMediaMutation, RemoveReactionFromMediaMutationVariables>(RemoveReactionFromMediaDocument, baseOptions);
}
export type RemoveReactionFromMediaMutationHookResult = ReturnType<typeof useRemoveReactionFromMediaMutation>;
export type RemoveReactionFromMediaMutationResult = Apollo.MutationResult<RemoveReactionFromMediaMutation>;
export type RemoveReactionFromMediaMutationOptions = Apollo.BaseMutationOptions<RemoveReactionFromMediaMutation, RemoveReactionFromMediaMutationVariables>;
